import { Box, FormControl, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Button, Typography, Divider, Grid, InputLabel, FormHelperText } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import ReactPaginate from 'react-paginate';
import Spinner from './spinner/spinner';
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { ConferenceCategory, conferencePaperPresenter, ConferenceSalutation } from '../constant/constant';
import { Controller, useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import logo from "../assets/images/logos/ELTA@I Logo Source File2.png";
import christLogo from "../assets/images/christLogo.jpg";
import './ConferenceInvoiceReceiptModal.css'
import { useDeleteRegistrationMutation, useGetAllRegisterMemberPaginationMutation, useGetMemberFeesByIdQuery, useLazyGetAllMemberFeesQuery } from '../app/services/conferenceService';
import { Delete } from '@material-ui/icons';
import { toast } from 'react-toastify';
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 500,
    minWidth: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};
function EnhancedTableHead() {
    const headCells = [
        { id: "Full Name", numeric: false, disablePadding: true, label: "Full Name" },
        { id: "Member ID", numeric: false, disablePadding: true, label: "Member ID" },
        {
            id: "Email",
            numeric: true,
            disablePadding: false,
            label: "Email ID",
        },
        {
            id: "Mobile Number",
            numeric: true,
            disablePadding: false,
            label: "Mobile Number",
        },
        {
            id: "Registration Category",
            numeric: true,
            disablePadding: false,
            label: "Registration Category",
        },
        // {
        //     id: "Presenter",
        //     numeric: true,
        //     disablePadding: false,
        //     label: "Presenter",
        // },
        {
            id: "Amount",
            numeric: true,
            disablePadding: false,
            label: "Amount",
        },
        {
            id: "Payment Date",
            numeric: true,
            disablePadding: false,
            label: "Payment Date",
        },
        {
            id: "Payment Status",
            numeric: true,
            disablePadding: false,
            label: "Payment Status",
        },
        {
            id: "Actions",
            numeric: false,
            disablePadding: false,
            label: "Actions",
            width: '200px'
        },

    ];
    return (
        <>
            <TableHead>
                <TableRow className="menus-color">
                    {headCells.map((headCell) => (
                        <TableCell
                            sx={{ textAlign: "center", color: "#ffff", minWidth: headCell?.width ? headCell.width : 'auto' }}
                            key={headCell.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                        >
                            {headCell.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        </>
    );
}
const GetCategoryName = ({ id }) => {
    const { data } = useGetMemberFeesByIdQuery(id, { refetchOnMountOrArgChange: true, skip: !id });
    return (
        <>
            {data?.data?.categoryName}
        </>
    )
}

const ConferenceMemberTable = () => {
    const [loading, setLoading] = useState(true);
    const [allMemberData, setAllMemberData] = useState([])
    const [page, setPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [error, setError] = useState("");
    const [getAllData] = useGetAllRegisterMemberPaginationMutation();
    const [getAllPlans] = useLazyGetAllMemberFeesQuery()
    const [deleteMember] = useDeleteRegistrationMutation()
    const [allPlans, setAllPlans] = useState(null)
    const [open, setOpen] = useState(false)

    const { control, handleSubmit, reset: filterReset, formState: { isDirty, isSubmitted }, getValues } = useForm({
        defaultValues: {
            registrationPlan: '',
            isPaid: '',
            conferenceNo: 19
        }, mode: 'onChange'
    })

    const getAllMemberData = useCallback(() => {
        const formData = getValues()
        const data = {
            ...formData, isPaid: formData?.isPaid ? Number(formData?.isPaid) : '',
            page: page + 1,
            itemsPerPage: itemsPerPage
        }
        setLoading(true)
        getAllData(data).then(res => {
            setLoading(false)
            if (res?.data?.status) {
                setAllMemberData(res?.data?.data?.registrationDetails)
                setTotalPage(res?.data?.data?.totalCount)
            }
            else {
                setAllMemberData([])
                setTotalPage(0)
            }
        }).catch(e => setLoading(false))
    }, [getAllData, getValues, page, itemsPerPage])
    useEffect(() => {
        getAllMemberData()
    }, [getAllMemberData])
    const resetTable = () => {
        filterReset({
            registrationPlan: '',
            isPaid: '',
            conferenceNo: 19
        })
        if (isDirty && isSubmitted) {
            setPage((prev) => prev = 0)
            setItemsPerPage(prev => prev = 10)
            getAllMemberData();
        }
        else {
            toast.warn('No filter applied')
        }
    }
    const filterData = (formData) => {
        setPage((prev) => prev = 0)
        setItemsPerPage(prev => prev = 10)
        getAllMemberData();
    }
    useEffect(() => {
        getAllPlans().then(res => {
            setAllPlans(res?.data?.data || [])
        })
    }, [page, itemsPerPage, getAllPlans])

    const handleOpenDelete = () => {
        setOpen(true)
    }
    const handleDeleteClose = () => {
        setOpen(false)
    }
    const handleDelete = () => {
        deleteMember(selectedMember._id).then(res => {
            if (res?.data?.status) {
                setOpen(false)
                toast.error(res?.data?.message)
                getAllMemberData()
            }
            else {
                toast.error(res?.data?.message)
            }
        })
    }


    //page Click for event type
    const handlePageClick = ({ selected }) => {
        setSearchTerm('')
        setError("");
        setPage(selected);
    };
    const [opens, setOpens] = useState(false);
    const [openView, setOpenView] = useState(false);

    const handleOpenView = () => setOpenView(true);
    const handleCloseView = () => {
        setOpenView(false);
    };
    const handleOpens = () => setOpens(true);
    const handleCloses = () => {
        setOpens(false);
    };
    const pageCount = Math.ceil(totalPage / itemsPerPage);

    const handlePageChange = () => {
        const pageNumber = Number(searchTerm);
        if (isNaN(pageNumber) || pageNumber < 0) {
            setError("Page number cannot be less than 1");
        } else if (pageNumber > pageCount) {
            setError("Please enter valid page number");
        } else if (pageNumber === 0) {
            setError("Please enter page number");
        } else {
            setError("");
            setPage(pageNumber - 1);
        }
    };
    const [selectedMember, setSelectedMember] = useState(null);
    const exportToPDF = () => {
        // Target the specific content within the modal
        const receiptContent = document.querySelector('#actual-receipt-display');
        if (!receiptContent) {
            console.error("Receipt content not found for PDF export.");
            return;
        }

        import('html2canvas').then(html2canvas => {
            import('jspdf').then(({ jsPDF }) => {
                html2canvas.default(receiptContent, { // Use receiptContent here
                    scale: 2,
                    useCORS: true,
                }).then(canvas => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF('p', 'mm', 'a4');
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                    pdf.save('Conference_Receipt.pdf');
                });
            });
        });
    };

    const downloadPdf = async () => {
        const formData = getValues()
        const data = {
            ...formData, isPaid: formData?.isPaid ? Number(formData?.isPaid) : '',
            page: 1,
            itemsPerPage: ''
        };
        setLoading(true);
        try {
            const res = await getAllData(data);
            setLoading(false);
            if (res?.data?.status) {
                const registrationDetails = res.data.data.registrationDetails || [];
                const registerPlanNames = {};
                const planMap = {};
                const fetchPlanNames = registrationDetails.map(async (item, index) => {
                    const planId = item.registrationPlan;
                    if (planId) {
                        try {
                            const planName = allPlans.find(plan => plan._id === planId).categoryName;
                            registerPlanNames[index] = planName;
                            planMap[planId] = planName;
                        } catch (e) {
                        }
                    }
                });
                await Promise.all(fetchPlanNames);
                // Only generate CSV if data is valid
                if (Array.isArray(registrationDetails)) {
                    generateCsv(registrationDetails, planMap);
                } else {
                }
            } else {
            }
        } catch (err) {
            setLoading(false);
        }
    };


    const categoryMap = ConferenceCategory.reduce((acc, cat) => {
        acc[cat.value] = cat.name;
        return acc;
    }, {});

    const paperPresenterMap = conferencePaperPresenter.reduce((acc, item) => {
        acc[item.value] = item.name;
        return acc;
    }, {});


    const generateCsv = (members, planMap = {}) => {
        if (!Array.isArray(members) || members.length === 0) {
            return;
        }

        // Include all the fields you want in the CSV
        const includedKeys = [
            "salutation",
            "fullName",
            "memberId",
            "email",
            "mobileNumber",
            "category",
            "otherCategory",
            "yourDesignation",
            "institutionName",
            "city",
            "state",
            "country",
            "otherCountry",
            "paperPresenter",
            "conferenceNo",
            "paymentDate",
            "amount",
            "paymentType",
            "registrationPlan",
            "isPaid",
            "invoiceId"
        ];

        // Map the headers to readable names
        const headerMapping = includedKeys.reduce((acc, key) => {
            acc[key] = key
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                .replace(/^(\w)/, match => match.toUpperCase());
            return acc;
        }, {});

        const formattedHeaders = Object.values(headerMapping).map(h => `"${h}"`);

        const csvRows = members.map((member) => {
            const formattedMember = {
                ...member,
                salutation:
                    member.salutation === 0 ? 'Mr' :
                        member.salutation === 1 ? 'Ms' :
                            member.salutation === 2 ? 'Mx' :
                                member.salutation === 3 ? 'Dr' :
                                    member.salutation === 4 ? 'Prof' : '',
                fullName: member.fullName || '-----',
                memberId: member.memberId || '-----',
                email: member.email || '-----',
                mobileNumber: member.mobileNumber || '-----',
                category: member.category
                    ? categoryMap[member.category] || 'Other'
                    : '-----',
                otherCategory: member.otherCategory || '-----',
                yourDesignation: member.yourDesignation || '-----',
                institutionName: member.institutionName || '-----',
                city: member.city || '-----',
                state: member.state || '-----',
                country: member.country || '-----',
                otherCountry: member.otherCountry || '-----',
                paperPresenter: member.paperPresenter
                    ? paperPresenterMap[member.paperPresenter] || '-----'
                    : '-----',

                conferenceNo: member.conferenceNo || '-----',
                paymentDate: member.paymentDate
                    ? new Date(member.paymentDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '-----',
                amount: member.amount || '-----',
                paymentType: member.paymentMethod || '-----',
                registrationPlan: planMap[member?.registrationPlan] || member?.registrationPlan || '-----',
                isPaid: member.isPaid === 0 ? 'Unpaid' : 'Paid',
                invoiceId: member.invoiceId || '-----'
            };

            return includedKeys
                .map(key => `"${(formattedMember[key] ?? "").toString().replace(/"/g, '""')}"`)
                .join(",");
        });

        const csvData = [formattedHeaders.join(","), ...csvRows].join("\n");

        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "members_data.csv";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };


    return (
        <>
            <div className="pt-5">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">Conference Registered Members</h2>
                </div>
            </div>
            {loading ? (
                <Spinner />
            ) :
                <div className='p-md-5 p-3 overallPadding'>
                    <Box
                        className=""
                    >
                        <Paper sx={{ width: "100%" }} className='shadow-none'>

                            <Box className='d-flex align-items-end justify-content-between mb-3 flex-md-row flex-column'>
                                <form className='w-75 mb-md-0 mb-3' onSubmit={handleSubmit(filterData)}>
                                    <Grid container rowSpacing={3} columnSpacing={2} className='d-flex align-items-start'>
                                        <Grid item xs={12} sm={6} md={6} lg={3}>
                                            <Controller
                                                control={control}
                                                rules={{ required: "Please select an option" }}
                                                name="registrationPlan"
                                                render={({ field, fieldState }) => (
                                                    <FormControl fullWidth>
                                                        <InputLabel className="text-dark" id="Salutation">
                                                            Registration Category
                                                            <span style={{ color: "red" }}>*</span>
                                                        </InputLabel>
                                                        <Select
                                                            className="bg-white"
                                                            labelId="registrationPlan"
                                                            id="registrationPlan"
                                                            label={
                                                                <Typography className="text-dark">
                                                                    Registration Category
                                                                    <span style={{ color: "red" }}>*</span>
                                                                </Typography>
                                                            }
                                                            value={field.value === "" ? "" : field.value}
                                                            variant="outlined"
                                                            onChange={(e) => {
                                                                field.onChange(e.target.value);
                                                            }}
                                                            error={!!fieldState.error}
                                                            fullWidth
                                                        >
                                                            {allPlans && allPlans.map((data) => (
                                                                <MenuItem key={data._id} value={data._id}>
                                                                    {data?.categoryName}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText error={fieldState?.error}>
                                                            {fieldState?.error?.message}
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6} lg={3}>
                                            <Controller
                                                control={control}
                                                rules={{ required: "Please select an option" }}
                                                name="conferenceNo"
                                                render={({ field, fieldState }) => (
                                                    <FormControl fullWidth>
                                                        <InputLabel className="text-dark" id="Salutation">
                                                            Conference Name
                                                            <span style={{ color: "red" }}>*</span>
                                                        </InputLabel>
                                                        <Select
                                                            className="bg-white"
                                                            labelId="registrationPlan"
                                                            id="registrationPlan"
                                                            label={
                                                                <Typography className="text-dark">
                                                                    Conference Name
                                                                    <span style={{ color: "red" }}>*</span>
                                                                </Typography>
                                                            }
                                                            value={field.value === "" ? "" : field.value}
                                                            variant="outlined"
                                                            onChange={(e) => {
                                                                field.onChange(e.target.value);
                                                            }}
                                                            error={!!fieldState.error}
                                                            fullWidth
                                                        >
                                                            <MenuItem value={19}>
                                                                The 19<sup>th</sup> Conference
                                                            </MenuItem>
                                                        </Select>
                                                        <FormHelperText error={fieldState?.error}>
                                                            {fieldState?.error?.message}
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6} lg={3}>
                                            <Controller
                                                control={control}
                                                rules={{ required: "Please select an option" }}
                                                name="isPaid"
                                                render={({ field, fieldState }) => (
                                                    <FormControl fullWidth>
                                                        <InputLabel className="text-dark" id="Salutation">
                                                            Payment Status
                                                            <span style={{ color: "red" }}>*</span>
                                                        </InputLabel>
                                                        <Select
                                                            className="bg-white"
                                                            labelId="registrationPlan"
                                                            id="registrationPlan"
                                                            label={
                                                                <Typography className="text-dark">
                                                                    Payment Status
                                                                    <span style={{ color: "red" }}>*</span>
                                                                </Typography>
                                                            }
                                                            value={field.value === "" ? "" : field.value}
                                                            variant="outlined"
                                                            onChange={(e) => {
                                                                field.onChange(e.target.value);
                                                            }}
                                                            error={!!fieldState.error}
                                                            fullWidth
                                                        >

                                                            <MenuItem value='1'>
                                                                Paid
                                                            </MenuItem>
                                                            <MenuItem value='0'>
                                                                In-progress
                                                            </MenuItem>

                                                        </Select>
                                                        <FormHelperText error={fieldState?.error}>
                                                            {fieldState.error?.message}
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6} lg={3} className='d-flex justify-content-between flex-md-row flex-sm-row-reverse gap-2 flex-column-reverse'>
                                            <div className="d-flex align-items-center justify-content-center mt-3 gap-2">
                                                <Button type="submit" variant="contained" className="ms-auto menus-color"  >Search</Button>
                                                <Button variant="outlined" color="error" className="rounded-0" onClick={resetTable}>Reset</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </form>
                                <div className='mb-2 text-end'>
                                    <Button onClick={() => downloadPdf()} variant="contained" className="ms-auto menus-color" >Download</Button>
                                </div>
                            </Box>
                            <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
                                <Table aria-labelledby="tableTitle">
                                    <EnhancedTableHead />
                                    <TableBody>
                                        {(allMemberData && allMemberData?.length > 0) ? (
                                            allMemberData.map((member, index) => (
                                                <TableRow
                                                    hover
                                                    key={member._id}
                                                    sx={{
                                                        cursor: "pointer",
                                                        backgroundColor: "white",
                                                    }}
                                                >
                                                    <TableCell align="center" border="none" >{ConferenceSalutation.find(a => a.id === member?.salutation).Name}{'. '}{member.fullName}</TableCell>
                                                    <TableCell align="center" >{member.memberId !== '' ? member.memberId : '-----'}</TableCell>
                                                    <TableCell align="center" >{member.email}</TableCell>
                                                    <TableCell align="center" >{member.mobileNumber}</TableCell>
                                                    <TableCell align="center" ><GetCategoryName id={member?.registrationPlan} /></TableCell>
                                                    {/* <TableCell align="center" >{member.paperPresenter}</TableCell> */}
                                                    <TableCell align="center" >{member?.dummyCurrency && member?.dummyCurrency.toString() === '0' ? '₹' : '$'}{member?.dummyAmount ? member?.dummyAmount : '-----'}</TableCell>
                                                    <TableCell align="center" >{member?.paymentDate ? member?.paymentDate.split('T')[0].split('-').reverse().join('-') : '-----'}</TableCell>
                                                    <TableCell align="center" >{member.isPaid === 1 ?
                                                        <>
                                                            <span style={{ color: 'green', fontWeight: 600 }}>Paid</span>
                                                        </> : <>
                                                            <span style={{ color: "rgb(118, 107, 203)", fontWeight: 600 }} >InProgress</span>
                                                        </>}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ verticalAlign: "middle" }}
                                                    >
                                                        <Box
                                                            display="flex"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            gap="8px"
                                                            flexWrap="wrap"
                                                        >
                                                            <Tooltip title="View" placement="top">
                                                                <IconButton
                                                                    aria-label="ViewIcon"
                                                                    onClick={() => {
                                                                        handleOpenView();
                                                                        setSelectedMember(member);
                                                                    }}
                                                                >
                                                                    <VisibilityIcon className="icon-vieweye-color" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            {member.isPaid === 1 ? (
                                                                <Tooltip title="View Receipt" placement="top">
                                                                    <IconButton
                                                                        aria-label="ViewIcon"
                                                                        onClick={() => {
                                                                            handleOpens();
                                                                            setSelectedMember(member);
                                                                        }}
                                                                    >
                                                                        <ReceiptIcon className="text-success" />
                                                                        {/* <ReceiptIcon className="icon-vieweye-color" /> */}
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip title="View" placement="top">
                                                                    <IconButton
                                                                        aria-label="ViewIcon"
                                                                        onClick={() => {
                                                                            handleOpenDelete();
                                                                            setSelectedMember(member);
                                                                        }}
                                                                    >
                                                                        <Delete className="text-danger" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </Box>
                                                    </TableCell>
                                                    {/* <TableCell
                                                    align="center" >
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        gap="8px"
                                                        flexWrap="wrap"
                                                    >
                                                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                                            {member?.isDeleted === 0 ? (
                                                                <Tooltip title="Enable" placement="top">
                                                                    <IconButton
                                                                        aria-label="enable"
                                                                        onClick={() => {
                                                                            handleEnableDisable(member._id);
                                                                        }}
                                                                    >
                                                                        <LockOpenIcon style={{ color: "green" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : member?.isDeleted === 2 ? (
                                                                <Tooltip title="Disable" placement="top">
                                                                    <IconButton
                                                                        aria-label="disable"
                                                                        onClick={() => {
                                                                            handleEnableDisable(member._id);
                                                                        }}
                                                                    >
                                                                        <LockIcon style={{ color: "red" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : null}
                                                        </div>
                                                    </Box>
                                                </TableCell> */}
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow sx={{
                                                cursor: "pointer",
                                                backgroundColor: "white",
                                            }}>
                                                <TableCell className='w-100' colSpan={9} align="center">
                                                    Will Be Added Shortly
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    <Modal open={opens} onClose={handleCloses} >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                maxHeight: '90vh',
                                                overflowY: 'auto',
                                                bgcolor: 'background.paper',
                                                p: 2,
                                                borderRadius: 2,
                                                width: 'fit-content',
                                                minWidth: 360,
                                            }}
                                        >
                                            {/* Header Action Row */}
                                            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                                                <IconButton onClick={handleCloses} size="small">
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>

                                            {/* Receipt Content */}
                                            {selectedMember && (
                                                <div className="receipt" id="actual-receipt-display">
                                                    <div className="header">
                                                        <div>
                                                            The 19<sup>th</sup> International & 55<sup>th</sup> Annual Conference of ELTAI on
                                                        </div>
                                                        <div className="sub-title">
                                                            LESSONS TAUGHT, LESSONS LEARNT:
                                                            <br /> TEACHER AND LEARNER NARRATIVES
                                                        </div>
                                                    </div>

                                                    <table className="org-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Organised By</th>
                                                                <th>Hosted By</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <img src={logo} alt="ELTAI Logo" className='invoice-logo' />
                                                                    <p>English Language Teachers' Association of India<br />(ELTAI)</p>
                                                                </td>
                                                                <td>
                                                                    <img src={christLogo} alt="Christ University Logo" className='invoice-logo' />
                                                                    <p>
                                                                        The Department of English and Cultural Studies,<br />
                                                                        Christ University,<br />
                                                                        Bengaluru
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div className="receipt-info">RECEIPT</div>

                                                    <table className="receipt-meta">
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: 'left' }}><strong>Receipt No.:</strong>&nbsp;Conf/2025/{selectedMember?.invoiceId ?? '-----'}</td>
                                                                <td style={{ textAlign: 'right' }}><strong>Date:</strong>&nbsp;{
                                                                    selectedMember?.paymentDate
                                                                        ? selectedMember.paymentDate.split('T')[0].split('-').reverse().join('-')
                                                                        : '-----'
                                                                }</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div className="main-content">
                                                        <p>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Received Rs. <strong>{selectedMember?.amount ?? '-----'}</strong>/- only with thanks from <strong>{ConferenceSalutation.find(i => i?.id === selectedMember?.salutation)?.Name}.{selectedMember?.fullName}</strong> towards the Registration Fee for the 19<sup>th</sup> International and 55<sup>th</sup> Annual Conference of ELTAI on
                                                            <em> "Lessons Taught, Lessons Learnt: Teacher and Learner Narratives"</em> hosted by the Department of English and Cultural Studies, Christ University, Bengaluru, from 12<sup>th</sup> to 15<sup>th</sup> November 2025.
                                                        </p>
                                                    </div>

                                                    <div className="details-container">
                                                        <div className="registration-details">
                                                            <table className='reg-table'>
                                                                <thead>
                                                                    <tr>
                                                                        <th colSpan={2}>Registration Details</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Type of Registration</td>
                                                                        <td>{selectedMember?.registrationPlan ? <GetCategoryName id={selectedMember?.registrationPlan} /> : '-----'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Mode of Payment</td>
                                                                        <td>Online Transaction</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Transaction Reference Number</td>
                                                                        <td>{selectedMember?.bankTransactionId ?? '-----'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Transaction Date</td>
                                                                        <td>{
                                                                            selectedMember?.paymentDate
                                                                                ? selectedMember.paymentDate.split('T')[0].split('-').reverse().join('-')
                                                                                : '-----'
                                                                        }</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="membership-details">
                                                            <table className='member1-table'>
                                                                <thead>
                                                                    <tr>
                                                                        <th colSpan={2}>ELTAI Membership Details</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Status</td>
                                                                        <td>{selectedMember?.memberId?.trim() ? 'Verified' : '---'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Membership ID</td>
                                                                        <td>{selectedMember.memberId !== '' ? selectedMember.memberId : '-----'}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <p className="signature-link" style={{ textAlign: 'right' }}>[Signature]</p>
                                                            <p style={{ textAlign: 'right' }}><strong>Dr. M. S. Xavier Pradheep Singh</strong><br />National Secretary, ELTAI</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                                <Button
                                                    variant="contained" className="menus-color"
                                                    onClick={exportToPDF}
                                                    startIcon={<DownloadIcon />}
                                                >
                                                    Download
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Modal>
                                    <Modal open={openView} onClose={handleCloseView} >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                maxHeight: '90vh',
                                                overflowY: 'auto',
                                                bgcolor: 'background.paper',
                                                p: 2,
                                                borderRadius: 2,
                                                maxWidth: 600,
                                                minWidth: 360,
                                                scrollbarWidth: 'none'
                                            }}
                                        >
                                            {/* Header Action Row */}
                                            <Box className='d-flex justify-content-between w-100 mt-1 align-items-center px-sm-0 px-3 '>
                                                <p className='fs-5 m-0 p-0'>Member Details:</p>
                                                <IconButton onClick={handleCloseView} size="small">
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>

                                            {/* Receipt Content */}
                                            {selectedMember && (
                                                <>
                                                    <div className='card teacher-member-card pt-3 w-100 '>
                                                        <div className='row'>
                                                            <div className="col-12">
                                                                <div className="container">
                                                                    <div className='row'>
                                                                        <div className="col-12">
                                                                            <div className="contact-details-grid">
                                                                                <p className="label signika-font fw-semibold">Full Name</p>
                                                                                <p className="value signika-font d-flex"><span className='me-3'>:</span><div>{ConferenceSalutation.find(a => a.id === selectedMember?.salutation).Name}{'. '}{selectedMember?.fullName}</div></p>
                                                                                {selectedMember?.memberId.length !== 0 &&
                                                                                    <>
                                                                                        <p className="label signika-font fw-semibold">Member ID</p>
                                                                                        <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.memberId}</p>
                                                                                    </>
                                                                                }
                                                                                <p className="label signika-font fw-semibold">Institution Name</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.institutionName}</p>
                                                                                <p className="label signika-font fw-semibold">Designation</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.yourDesignation}</p>
                                                                                <p className="label signika-font fw-semibold">City / Town</p>
                                                                                <p className="value signika-font"><span className='me-3'>:</span>{selectedMember?.city}</p>
                                                                                <p className="label signika-font fw-semibold">State</p>
                                                                                <p className="value signika-font"><span className='me-3'>:</span>{selectedMember?.state}</p>
                                                                                <p className="label signika-font fw-semibold">Country</p>
                                                                                <p className="value signika-font"><span className='me-3'>:</span>{selectedMember?.country.length === 0 ? selectedMember?.otherCountry : selectedMember?.country}</p>
                                                                                <p className="label signika-font fw-semibold">Mobile Number</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.mobileNumber}</p>
                                                                                <p className="label signika-font fw-semibold">Email</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.email}</p>
                                                                                <p className="label signika-font fw-semibold">Registration Category</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span><GetCategoryName id={selectedMember?.registrationPlan} /></p>
                                                                                <p className="label signika-font fw-semibold">Member Category</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.category ? ConferenceCategory.find(a => a.value === selectedMember?.category).name : selectedMember?.otherCategory}</p>
                                                                                <p className="label signika-font fw-semibold">Paper Presenter Category</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{conferencePaperPresenter.find(a => a.value === selectedMember?.paperPresenter).name}</p>
                                                                                <p className="label signika-font fw-semibold">Amount</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.dummyCurrency.toString() === '0' ? '₹' : '$'}{selectedMember?.dummyAmount}</p>
                                                                                <p className="label signika-font fw-semibold">Payment Status</p>
                                                                                <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.isPaid === 1 ?
                                                                                    <>
                                                                                        <span style={{ color: 'green', fontWeight: 600 }}>Paid</span>
                                                                                    </> : <>
                                                                                        <span style={{ color: "rgb(118, 107, 203)", fontWeight: 600 }} >InProgress</span>
                                                                                    </>}
                                                                                </p>
                                                                                {selectedMember?.isPaid === 1 &&
                                                                                    <>
                                                                                        <p className="label signika-font fw-semibold">Payment Date</p>
                                                                                        <p className='signika-font text-capitalize'><span className='me-3'>:</span>{selectedMember?.paymentDate.split('T')[0].split('-').reverse().join('-')}</p>
                                                                                        <p className="label signika-font fw-semibold">Payment Method</p>
                                                                                        <p className='signika-font text-capitalize'><span className='me-3'>:</span>{selectedMember?.paymentMethod}</p>
                                                                                        <p className="label signika-font fw-semibold">Bank Transaction ID</p>
                                                                                        <p className='signika-font'><span className='me-3'>:</span>{selectedMember?.bankTransactionId}</p>
                                                                                    </>
                                                                                }



                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                                <Button
                                                    variant="outlined" color='error'
                                                    onClick={handleCloseView}
                                                // startIcon={<DownloadIcon />}
                                                >
                                                    Close
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Modal>


                                    {/* <Modal
                                    open={open1}
                                    onClose={handleClose1}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Grid sx={style1} container className='overflow-y-scroll' maxWidth={'sm'}>
                                        <Container maxWidth={false} sx={{ px: 3 }}>
                                            <Box className="d-flex justify-content-between pt-2">
                                                <Typography variant="h5" className="fw-bold" sx={{ color: "#0d4022 !important", fontWeight: "bold" }}>
                                                    View member Content
                                                </Typography>
                                                <IconButton onClick={handleClose1} aria-label="Close">
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>
                                        </Container>
                                        <Box display="flex" justifyContent="center" width="100%" className='mb-2'>
                                            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                                        </Box>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }} >Desktop member Image</h4>
                                            <img src={selectedmember?.desktopmemberImage} className='w-75 img-fluid' alt="" />
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }}>Mobile member Image</h4>
                                            <img src={selectedmember?.mobilememberImage} className='w-75 img-fluid' alt="" />
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }}>member Text Content</h4>
                                            <p className='alata-regular'>{selectedmember?.text}</p>
                                        </Grid>
                                        <Grid item xs={12} mb={3}>
                                            <h4 className='alata-regular title-font' style={{ color: "#611f1e" }}>Button Link</h4>
                                            <a className='alata-regular' href={selectedmember?.buttonLink}>{selectedmember?.buttonLink}</a>

                                        </Grid>

                                    </Grid>
                                </Modal>
                                */}
                                </Table>
                            </TableContainer>
                        </Paper>
                        <br />
                        {allMemberData.length > 0 ? (
                            <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font align-items-center">
                                <div className="mb-2 mb-md-0">
                                    <div className="d-flex gap-2">
                                        <input
                                            type="number"
                                            min={1}
                                            placeholder="Page no."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                        <div className="goPage cursor-pointer" onClick={handlePageChange}>
                                            <h5 className="p-2 m-0">Go</h5>
                                        </div>
                                    </div>
                                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                                </div>

                                {/* Pagination in the Center */}
                                <div className="my-3 my-md-0">
                                    <ReactPaginate
                                        pageCount={pageCount} // Calculate total pages
                                        pageRangeDisplayed={1}
                                        marginPagesDisplayed={1}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        activeClassName={"active"}
                                        previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                                        nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
                                        disabledClassName={"disablebtn"}
                                        forcePage={page}
                                    />
                                </div>
                                <div className="mb-2 mb-md-0">
                                    <FormControl variant="outlined">
                                        <Select
                                            className="itemsperpage"
                                            value={itemsPerPage}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setItemsPerPage(value);
                                                setError('')
                                                setSearchTerm('');
                                                setPage(0)
                                            }}
                                            MenuProps={{
                                                MenuListProps: {
                                                    sx: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value={10} className="Event-menu">10</MenuItem>
                                            <MenuItem value={20} className="Event-menu">20</MenuItem>
                                            <MenuItem value={50} className="Event-menu">50</MenuItem>
                                            <MenuItem value={100} className="Event-menu">100</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                    </Box>
                    <br />
                </div >
            }
            <Modal
                open={open}
                onClose={handleDeleteClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={style}
                    className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
                >

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                            Confirmation
                        </Typography>
                        <IconButton onClick={handleDeleteClose} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <Box display="flex" justifyContent="center" width="100%">
                        <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                    </Box>
                    <Typography
                        id="modal-modal-title"
                        style={{ color: "#611f1e" }}
                        variant="h6"
                        component="h2"
                        className="content-font"
                    >
                        Are You Surely Want to Delete this member?
                    </Typography>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            variant="outlined"
                            className="content-font"
                            style={{

                                color: "#dc3545",
                                border: "1px solid #dc3545",
                                padding: "5px 15px",
                                borderRadius: "0px",
                            }}
                            onClick={handleDeleteClose}
                        >
                            No
                        </Button>
                        <Button
                            className="mx-2 content-font"
                            variant="contained"
                            style={{
                                backgroundColor: "#2e7d32",
                                color: "white",
                                padding: "5px 15px",
                                borderRadius: "0px",
                            }}
                            onClick={() => handleDelete()}
                        >
                            Yes
                        </Button>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default ConferenceMemberTable